import { useSelector } from 'react-redux';

import { conversionKitModel } from '../../../features/conversion-kit';
import { CollaborationConnectionProvider } from '../../../entities/collaboration';
import {
  SharePageModal,
  SharePageModalPlaceholder,
} from '../../new-editor/ui/components/share-page-modal';

import { pagesModel } from '../../../features/pages';

import { collaborationModel } from '../../../entities/collaboration/model';

import { FC } from 'react';

type Props = {
  isOpen: boolean;
  onClose: () => void;
};

export const WorkspaceShareModal: FC<Props> = ({ isOpen, onClose }) => {
  const currentPage = useSelector(pagesModel.selectors.selectCurrentPage);

  const requireEmailToView = useSelector(
    conversionKitModel.selectors.selectRequireEmailToView
  );
  const alertBar = useSelector(conversionKitModel.selectors.selectAlertBar);
  const popUp = useSelector(conversionKitModel.selectors.selectPopUp);
  const cta = useSelector(conversionKitModel.selectors.selectCTA);
  const gatedContent = useSelector(
    conversionKitModel.selectors.selectGatedContent
  );
  const squeezePage = useSelector(
    conversionKitModel.selectors.selectSqueezePage
  );

  const isCollaborationLoaded = useSelector(
    collaborationModel.selectors.selectIsLoaded
  );

  const isShareModalAvailable =
    currentPage &&
    alertBar &&
    popUp &&
    squeezePage &&
    gatedContent &&
    cta &&
    requireEmailToView;

  return (
    <>
      {isShareModalAvailable && (
        <div className="absolute top-0 left-0 w-full h-full pointer-events-none">
          <CollaborationConnectionProvider hideLoader={true}>
            {isOpen && isCollaborationLoaded && (
              <SharePageModal isOpen={isOpen} onClose={onClose} />
            )}
          </CollaborationConnectionProvider>
        </div>
      )}
      {isOpen && !isCollaborationLoaded && (
        <SharePageModalPlaceholder isOpen={true} onClose={onClose} />
      )}
    </>
  );
};
